/* All engagement-page copy in English and Hindi. */

const STRINGS = {
  en: {
    kicker: "Godbharai · Bariksha · Engagement",
    invite1: "The Pandey & Shukla families request",
    invite2: "the honour of your presence at the sagai of",
    parentsKicker: "With the blessings of",
    brideParentsLabel: "Parents of the Bride",
    groomParentsLabel: "Parents of the Groom",
    names: ["Divyanshi", "&", "Divya Shiv"],
    heroDate: "3rd of November, 2026",
    heroVenue: "Hotel SB Castle · Kanpur · 4 o’clock onwards",

    famKicker: "Two families, one blessing",
    famTitle: "With the blessings of our parents",
    bride: "The Bride",
    brideName: "Divyanshi Shukla",
    daughterOf: "daughter of",
    brideParents: "Mr. Rajeev Shukla & Mrs. Vandana Shukla",
    groom: "The Groom",
    groomName: "Divya Shiv Pandey",
    sonOf: "son of",
    groomParents: "Mr. Virendra Pandey & Mrs. Alka Pandey",
    famNote:
      "“Before the wedding bells, a quiet promise — made in front of everyone we love.”",

    countKicker: "The Countdown",
    countTitle: "Until two hearts wear one promise",
    units: { days: "Days", hours: "Hours", mins: "Minutes", secs: "Seconds" },
    countNote: "The first knot of many.",

    ritKicker: "The order of the evening",
    ritTitle: "An evening of three rituals",
    ritTime: "4 PM Onwards",
    tlFirst: "4:00 PM",
    tlNext: "Followed by",
    tlArrival: "Guest Arrival & Welcome",
    tlArrivalQuote:
      "Kindly arrive by 4 o'clock, so the rituals may begin on time.",
    ceremonies: [
      {
        key: "godbharai",
        num: "Ritual I",
        name: "Godbharai",
        quote: "A lap filled with blessings, sweets & the warmth of every elder's love.",
        note: "Blessings of the family",
      },
      {
        key: "bariksha",
        num: "Ritual II",
        name: "Bariksha",
        quote: "The families meet, words are given, and two homes become one promise.",
        note: "The word of honour",
      },
      {
        key: "ring-ceremony",
        num: "Ritual III",
        name: "Ring Ceremony",
        quote: "Two rings, one promise — the first circle of forever.",
        note: "The Sagai",
      },
    ],

    venueKicker: "Where we gather",
    venueName: "Hotel SB Castle",
    venueAddr1: "Near Govind Nagar Bridge, Fazalganj",
    venueAddr2: "Kanpur, Uttar Pradesh",
    venueTime: "3 November 2026 · 4:00 PM onwards",
    mapBtn: "View on Map",
    calGoogle: "Google Calendar",
    calApple: "Apple / Outlook",
    rsvpBtn: "RSVP · Confirm Attendance",

    blessKicker: "Ashirwad",
    blessTitle: "Leave your blessings",
    blessSub: "A few words from you will stay with us forever.",
    blessName: "Your name",
    blessMsg: "Your blessing for the couple",
    blessBtn: "Send blessing",
    blessSending: "Sending…",
    blessThanks: "Thank you for your blessings!",
    blessEmpty: "Be the first to bless the couple.",

    footLine: "Your presence is the blessing we are waiting for.",
    footFam1: "With love & folded hands,",
    footFam2: "The Pandey & Shukla Families",
    footLink: "The Wedding · 26 November 2026",

    envKicker: "Sagai · 3 Nov 2026",
    envNames: ["Divyanshi", "Divya Shiv"],
    envHint: "Tap to open your invitation",

    musicOn: "Music on",
    musicOff: "Music",
  },

  hi: {
    kicker: "गोदभराई · बरीक्षा · सगाई",
    invite1: "पांडेय एवं शुक्ला परिवार, सगाई के शुभ अवसर पर",
    invite2: "आपकी गरिमामयी उपस्थिति के अभिलाषी हैं",
    parentsKicker: "आशीर्वाद सहित",
    brideParentsLabel: "वधू के माता-पिता",
    groomParentsLabel: "वर के माता-पिता",
    names: ["दिव्यांशी", "&", "दिव्य शिव"],
    heroDate: "3 नवम्बर 2026",
    heroVenue: "होटल एसबी कैसल · कानपुर · सायं 4 बजे से",

    famKicker: "दो परिवार, एक आशीर्वाद",
    famTitle: "माता-पिता के आशीर्वाद सहित",
    bride: "वधू",
    brideName: "दिव्यांशी शुक्ला",
    daughterOf: "सुपुत्री",
    brideParents: "श्री राजीव शुक्ला एवं श्रीमती वंदना शुक्ला",
    groom: "वर",
    groomName: "दिव्य शिव पांडेय",
    sonOf: "सुपुत्र",
    groomParents: "श्री वीरेंद्र पांडेय एवं श्रीमती अलका पांडेय",
    famNote:
      "“शादी की घंटियों से पहले एक कोमल वचन — अपनों के सामने, अपनों के नाम।”",

    countKicker: "उलटी गिनती",
    countTitle: "जब दो दिल एक वचन में बंधेंगे",
    units: { days: "दिन", hours: "घंटे", mins: "मिनट", secs: "सेकंड" },
    countNote: "हर पल, साथ की ओर।",

    ritKicker: "संध्या का क्रम",
    ritTitle: "तीन रस्मों की एक शाम",
    ritTime: "सायं 4 बजे से",
    tlFirst: "सायं 4:00 बजे",
    tlNext: "तत्पश्चात्",
    tlArrival: "आगमन एवं स्वागत",
    tlArrivalQuote:
      "कृपया सायं 4 बजे तक पधारें, ताकि रस्में समय पर आरम्भ हो सकें।",
    ceremonies: [
      {
        key: "godbharai",
        num: "रस्म I",
        name: "गोदभराई",
        quote: "आशीर्वाद से भरी गोद, मिठास और बड़ों का स्नेह।",
        note: "परिवार का आशीर्वाद",
      },
      {
        key: "bariksha",
        num: "रस्म II",
        name: "बरीक्षा",
        quote: "दो परिवार मिलते हैं, वचन दिए जाते हैं, और दो घर एक संकल्प बन जाते हैं।",
        note: "वचन की रस्म",
      },
      {
        key: "ring-ceremony",
        num: "रस्म III",
        name: "अंगूठी की रस्म",
        quote: "दो अंगूठियाँ, एक वादा — हमेशा का पहला घेरा।",
        note: "सगाई",
      },
    ],

    venueKicker: "आमंत्रण स्थल",
    venueName: "होटल एसबी कैसल",
    venueAddr1: "गोविंद नगर पुल के पास, फज़लगंज",
    venueAddr2: "कानपुर, उत्तर प्रदेश",
    venueTime: "3 नवम्बर 2026 · सायं 4 बजे से",
    mapBtn: "मानचित्र देखें",
    calGoogle: "Google कैलेंडर",
    calApple: "Apple / Outlook",
    rsvpBtn: "उपस्थिति की पुष्टि करें",

    blessKicker: "आशीर्वाद",
    blessTitle: "अपना आशीर्वाद लिखिए",
    blessSub: "आपके कुछ शब्द हमारे साथ सदा रहेंगे।",
    blessName: "आपका नाम",
    blessMsg: "वर-वधू के लिए आपका आशीर्वाद",
    blessBtn: "आशीर्वाद भेजें",
    blessSending: "भेजा जा रहा है…",
    blessThanks: "आपके आशीर्वाद के लिए धन्यवाद!",
    blessEmpty: "सबसे पहले आशीर्वाद देने वाले बनें।",

    footLine: "आपकी उपस्थिति ही हमारा सबसे बड़ा आशीर्वाद है।",
    footFam1: "सप्रेम एवं सादर,",
    footFam2: "पांडेय एवं शुक्ला परिवार",
    footLink: "विवाह · 26 नवम्बर 2026",

    envKicker: "सगाई · 3 नवम्बर 2026",
    envNames: ["दिव्यांशी", "दिव्य शिव"],
    envHint: "निमंत्रण खोलने के लिए स्पर्श करें",

    musicOn: "संगीत चालू",
    musicOff: "संगीत",
  },
};

export default STRINGS;
